var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"swap-btn",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"d-flex flex-column justify-center align-center"},[_c('span',{staticClass:"swap-btn__arrow mt-1"},[_vm._v("→")]),_c('span',{staticClass:"swap-btn__arrow mt-2"},[_vm._v("←")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }